import { Component } from '@angular/core';
import { BasicDialogComponent } from '@shared/components/dialogs/basic-dialog.component';

@Component({
    standalone: false,
    selector: 'app-member-state-dialog',
    templateUrl: './member-state-dialog.component.html'
})
export class MemberStateDialogComponent extends BasicDialogComponent {

    constructor() {
        super();
    }
}
